import elevateClient from "@server/elevate";
import makeProductRules from "@server/requests/elevate/makeProductRules";
import type { QueryClient } from "@tanstack/react-query";
import { deleteCookie, setCookie } from "cookies-next";
import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import type { MouseEvent } from "react";

import type { Market } from "@features/market/config/i18n-config";
import {
  findMarketByCode,
  getMarketSwitchHref,
} from "@features/market/config/market-config";

export async function interceptRoute(
  event: MouseEvent<HTMLAnchorElement>,
  router: AppRouterInstance,
  currentMarket: Market,
  qc: QueryClient,
) {
  event.preventDefault();
  const lang = event.currentTarget.getAttribute("data-lang");
  const market = event.currentTarget.getAttribute("data-market");
  const targetMarket = findMarketByCode(market ?? currentMarket.countryCode);
  if (targetMarket.countryCode === currentMarket.countryCode) {
    setCookie("ng_lang", targetMarket.languageCode);
    setCookie("ng_market", targetMarket.countryCode);
    deleteCookie("ng_suggestion");
    return qc.setQueryData(["market"], { open: false });
  }
  const session = window.sessionStorage.getItem("siblings");
  let pathname = "";
  if (session) {
    if (session.includes("product")) {
      const [, id] = session.split(":");
      const response = await elevateClient(targetMarket).query.landingPage(
        { pageReference: "/intercept-route" },
        {
          primaryList: {
            include: true,
            productRules: makeProductRules([id]),
          },
        },
      );
      const product = response.primaryList?.productGroups[0].products[0];
      const variant = product?.variants[0];
      if (variant?.link) pathname += variant.link;
      else if (product?.link) pathname += product.link;
    } else {
      const links = JSON.parse(session);
      if (lang && links[lang]) pathname += links[lang];
    }
  }
  const origin = getMarketSwitchHref(currentMarket, targetMarket);
  setCookie("ng_lang", lang);
  setCookie("ng_market", targetMarket.countryCode);
  deleteCookie("ng_suggestion");
  return router.push(origin + pathname);
}
